<template>
    <div class="contactUs">
     <first />
     <second />
     <third />
    </div>
</template>
<script src="./contact.js"></script>
<style src="./contact.css"></style>